const state = {
    appInvoiceList: []
}

const mutations = {
    SET_APP_INVOICE_LIST(state, payload) {
        state.appInvoiceList = payload;
    }
}

const actions = {
    getAppInvoiceList({commit}, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/ap-invoice`, {
                params: {
                    page: params.page,
                    limit: params.limit,
                    filter: params.filter
                }
            })
                .then(response => {
                    commit('SET_APP_INVOICE_LIST', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    }
}

const getters = {
    appInvoiceList: state => state.appInvoiceList
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}